import {
  FaUserAlt,
  FaChevronDown,
  FaTrophy,
  FaUserMd,
  FaSyringe,
  FaMedal,
  FaAward,
  FaFlask,
} from "react-icons/fa";
import StoriesSection from "./StoriesSection";
import { useEffect, useRef, useState } from "react";
import BeforeAfterSlider from "./BeforeAfterSlider";
import Contact from "./Contact";
import TestimonialSlider from "./TestimonialSlider";
import { useTranslation, Trans } from "react-i18next";

export default function HeroWithFeatures() {
  const { t } = useTranslation();

  const whatsappLink = "https://wa.me/905452523725";

  const FOTO = "/foto.jpg";

  const dokuImages = [
    { id: 1, src: "/diş1.jpg", altKey: "doku_img_alt_1" },
    { id: 2, src: "/muayenehane.jpeg", altKey: "doku_img_alt_2" },
    { id: 3, src: "/diş3.jpg", altKey: "doku_img_alt_3" },
    { id: 4, src: "/diş2.jpg", altKey: "doku_img_alt_4" },
  ];

  const [selectedCountry, setSelectedCountry] = useState({
    flag: "🇹🇷",
    code: "+90",
  });
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current && scrollRef.current.children?.[1]) {
      const secondCardOffset = scrollRef.current.children[1].offsetLeft;
      scrollRef.current.scrollLeft = secondCardOffset;
    }
  }, []);

  const badgeItems = [
    { icon: <FaUserAlt size={38} />, textKey: "badges_1" },
    { icon: <FaTrophy size={38} />, textKey: "badges_2" },
    { icon: <FaUserMd size={38} />, textKey: "badges_3" },
    { icon: <FaSyringe size={38} />, textKey: "badges_4" },
  ];

  return (
    <>
      {/* HERO */}
      <section className="relative flex flex-col items-center justify-center min-h-[700px] px-2 sm:px-4 pt-12 pb-[112px] bg-[#202844] overflow-visible">
        {/* <video
          className="absolute inset-0 w-full h-full object-cover z-0"
          src="/video.mp4"
          autoPlay
          loop
          muted
          playsInline
        /> */}
        <img
          className="absolute inset-0 w-full h-full object-cover z-0"
          src="/muayenehane.jpeg"
          alt="Background"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-[#0b1224] opacity-80 z-10" />
        <div className="relative z-20 flex flex-col items-center justify-center text-center w-full max-w-3xl px-2">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#e8d1b9] mb-2 drop-shadow-lg">
            {t("hero_h1_top")}
          </h1>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#e8d1b9]/80 mb-6 whitespace-pre-line">
            <Trans i18nKey="hero_h2_main" />
          </h2>
          <p className="text-base sm:text-lg text-white mb-2 font-light leading-relaxed">
            {t("hero_line1")}
          </p>
          <p className="text-base sm:text-lg text-white mb-6 font-light leading-relaxed">
            {t("hero_line2")}
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-[#c2a484] to-[#e8d1b9] text-[#1a2235] text-base sm:text-lg font-semibold px-4 sm:px-8 py-3 sm:py-4 rounded-full shadow-lg hover:scale-105 transition-transform inline-flex items-center gap-2 cursor-pointer"
          >
            {t("hero_cta")}
          </a>
        </div>

        {/* 4’lü kart hero'nun içinde alt kenara sabit */}
        <div className="absolute left-0 right-0 bottom-0 translate-y-1/2 z-30">
          <div className="mx-auto max-w-6xl px-2">
            <div className="isolate bg-[#19296a] rounded-3xl sm:rounded-[64px] shadow-xl px-4 sm:px-10 md:px-16 py-6 sm:py-12">
              {/* Mobil: yatay slider */}
              <div
                ref={scrollRef}
                className="flex sm:hidden overflow-x-auto gap-3 -mx-2 px-2 snap-x snap-mandatory touch-pan-x hero-slider-hide-scrollbar"
              >
                {badgeItems.map((item, i) => (
                  <div
                    key={i}
                    className="flex flex-col items-center text-center min-w-[72%] xs:min-w-[260px] flex-shrink-0 bg-[#243b8a] rounded-2xl py-5 px-4 snap-center"
                  >
                    <div className="mb-3 text-[#e8d1b9]">{item.icon}</div>
                    <div className="text-base text-[#e8d1b9] font-bold leading-snug whitespace-pre-line">
                      <Trans i18nKey={item.textKey} />
                    </div>
                  </div>
                ))}
              </div>

              {/* Masaüstü: yan yana */}
              <div className="hidden sm:flex justify-between items-center gap-8">
                {badgeItems.map((item, i) => (
                  <div
                    key={i}
                    className="flex flex-col items-center text-center flex-1 transition-transform hover:-translate-y-0.5"
                  >
                    <div className="mb-3 text-[#e8d1b9]">{item.icon}</div>
                    <div className="text-lg text-[#e8d1b9] font-bold leading-snug whitespace-pre-line">
                      <Trans i18nKey={item.textKey} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sonraki Section */}
      <section className="pt-[80px] bg-[#0b1224] min-h-[400px] w-full flex flex-col items-center">
        <div
          id="neden"
          className="flex flex-col md:flex-row items-center justify-center gap-10 md:gap-16 w-full max-w-6xl px-4"
        >
          {/* SOL: Görsel */}
          <div className="bg-[#0b1224]  md:pt-0  flex-1">
            <img
              src={FOTO}
              className=" object-contain mx-auto"
              alt={t("alt_clinic") || "Clinic"}
            />
          </div>

          {/* SAĞ: Yazı (sağa dayalı) */}
          <div className="flex-1 flex flex-col items-end text-right md:mt-0">
            <h2 className="text-2xl md:text-4xl font-bold text-[#e8d1b9] mb-4 md:mb-6">
              {t("why_block_title")}
            </h2>
            <p className="text-base md:text-lg text-white mb-6 max-w-xl">
              {t("why_block_desc")}
            </p>
          </div>
        </div>
      </section>

      {/* Değişimin Adresi Kutusu */}
      <div className="w-full flex justify-center pb-8 sm:pb-12 bg-[#0b1224] px-2">
        <div className="w-full max-w-5xl rounded-2xl md:rounded-3xl bg-gradient-to-tr from-[#bda088] to-[#a89281] flex flex-col items-center px-4 sm:px-8 md:px-20 py-6 md:py-10 shadow-xl">
          {/* Logo */}

          {/* Başlıklar */}
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#232c3b] mb-2 sm:mb-3 text-center">
            {t("cta_block_title_top")}
          </h2>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-[#232c3b] mb-2 sm:mb-3 text-center leading-tight whitespace-pre-line">
            <Trans i18nKey="cta_block_title_main" />
          </h1>

          {/* Açıklama */}
          <p className="text-sm sm:text-base md:text-lg text-[#232c3b] text-center mb-5 sm:mb-6 font-medium">
            {t("cta_block_desc")}
          </p>

          {/* Buton */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-[#232c3b] to-[#42342c] hover:from-[#42342c] hover:to-[#232c3b] text-white text-sm sm:text-base font-bold px-5 sm:px-8 py-2.5 sm:py-3.5 rounded-full shadow-md transition-all duration-200 flex items-center gap-2 mb-1 border-2 border-[#82705c] hover:border-[#c2a484]"
          >
            {t("cta_block_button")}
            <span role="img" aria-label="pointer">
              🖱️
            </span>
          </a>

          {/* Yanıp sönen bilgi */}
          <div className="flex items-center justify-center gap-1.5 animate-pulse">
            <span className="text-[#232c3b] text-base">●</span>
            <span className="text-[#232c3b] font-medium text-sm sm:text-base">
              {t("cta_block_hint")}
            </span>
          </div>
        </div>
      </div>

      <StoriesSection />

      <div className="pt-2">
        <BeforeAfterSlider />
      </div>

      {/* Form + Görsel */}
   <div className="bg-[#19203a] w-full">
  <div className="mx-auto w-full max-w-6xl px-4 py-8 sm:py-12">
    {/* GRID: mobil 1 sütun, lg 2 sütun */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-stretch">
      {/* SOL: FORM */}
      <div className="min-w-0"> {/* overflow/taşmayı engeller */}
        <div className="bg-[#141b33] rounded-2xl sm:rounded-[40px] p-6 sm:p-8 h-full flex flex-col justify-center shadow-xl">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#e8d1b9] mb-3 sm:mb-4 leading-tight text-center lg:text-left">
            {t("form_title")}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#bfc7d5] mb-5 sm:mb-6 text-center lg:text-left">
            {t("form_desc")}
          </p>

          <form className="space-y-4 sm:space-y-5">
            {/* Ad Soyad */}
            <input
              type="text"
              placeholder={t("form_name_placeholder")}
              className="w-full rounded-full px-5 sm:px-6 py-3 sm:py-4 bg-[#192147] text-white focus:outline-none placeholder-[#bfc7d5] text-base sm:text-lg"
            />

            {/* Telefon */}
            <div className="flex overflow-hidden rounded-full bg-[#192147]">
              {/* Ülke kodu */}
              <button
                type="button"
                className="w-20 sm:w-24 flex-shrink-0 pl-3 sm:pl-4 pr-3 py-2.5 sm:py-3 flex items-center gap-2 text-white bg-[#29305a] border-r border-white/10 outline-none"
                tabIndex={-1}
              >
                <span>{selectedCountry.flag}</span>
                <span className="text-sm sm:text-base">{selectedCountry.code}</span>
                <FaChevronDown className="ml-auto text-xs sm:text-sm" />
              </button>

              {/* Numara */}
              <input
                type="tel"
                placeholder={t("form_phone_placeholder")}
                className="flex-1 min-w-0 px-4 sm:px-5 py-2.5 sm:py-3 bg-transparent text-white placeholder-[#bfc7d5] outline-none text-base sm:text-lg"
                inputMode="tel"
              />
            </div>

            {/* E-posta */}
            <input
              type="email"
              placeholder={t("form_email_placeholder")}
              className="w-full rounded-full px-5 sm:px-6 py-3 sm:py-4 bg-[#192147] text-white focus:outline-none placeholder-[#bfc7d5] text-base sm:text-lg"
            />

            {/* KVKK */}
            <div className="flex items-start gap-2">
              <input id="kvkk" type="checkbox" className="mt-1" />
              <label htmlFor="kvkk" className="text-xs text-[#bfc7d5] leading-tight">
                {t("form_kvkk")}
              </label>
            </div>

            {/* CTA buton (shine) */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-8 sm:mt-10 rounded-full px-6 sm:px-7 py-3 sm:py-4
                         text-[#232c3b] font-semibold shadow transition
                         [background-image:linear-gradient(90deg,#bda088,#e8d1b9,#bda088)]
                         bg-[length:200%_200%]
                         hover:animate-[shine_1.2s_linear_infinite]
                         hover:shadow-lg border border-white/10 text-sm sm:text-base"
            >
              {t("doku_cta")}
              <span aria-hidden>🖱️</span>
            </a>
          </form>
        </div>
      </div>

      {/* SAĞ: FOTOĞRAF */}
      <div className="min-w-0"> {/* taşma koruması */}
        {/* Oranlı kapsayıcı: mobilde 16:10, md’de otomatik yükseklik */}
        <div className="relative w-full rounded-2xl sm:rounded-[40px] overflow-hidden shadow-xl bg-[#0e1430] aspect-[16/10] md:aspect-auto md:h-[520px]">
          <img
            src={"/fotoYeni.webp"}
            alt={t("brand")}
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Google Reviews Badge */}
          <div className="absolute top-3 sm:top-4 left-3 sm:left-4 bg-gradient-to-r from-[#e7cbb3] to-[#bda088] rounded-lg sm:rounded-xl px-4 sm:px-6 py-2 sm:py-3 shadow-lg flex flex-col items-center">
            <span className="font-semibold text-[#232c3b] text-sm sm:text-base">Google</span>
            <span className="font-bold text-[10px] sm:text-xs text-[#232c3b] -mt-1">
              {t("reviews_badge")}
            </span>
            <span className="font-extrabold text-xl sm:text-3xl text-[#232c3b] mt-1">4,8</span>
          </div>

          {/* Alt Etiket */}
          <div className="absolute bottom-3 sm:bottom-4 left-1/2 -translate-x-1/2 bg-white/90 px-5 sm:px-8 py-2 sm:py-3 rounded-full text-[#232c3b] text-sm sm:text-lg font-medium shadow">
            {t("brand_short") || "Dişçinim"}
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* shine animasyonu (eğer globalde yoksa) */}
  <style>{`
    @keyframes shine {
      0% { background-position: 0% 50%; }
      100% { background-position: 100% 50%; }
    }
    .animate-\\[shine_1\\.2s_linear_infinite\\] {
      animation: shine 1.2s linear infinite;
    }
  `}</style>
</div>


      <TestimonialSlider />

      <section className="bg-[#0b1224] w-full">
        <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20">
          {/* grid: sol metin / sağ görseller */}
          <div
            className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start"
            id="doku"
          >
            {/* SOL: Başlık + açıklama + CTA */}
            <div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-[#e8d1b9] leading-tight whitespace-pre-line">
                <Trans i18nKey="doku_title" />
              </h2>

              <p className="mt-6 text-[#cfd6e4] text-lg leading-8 max-w-xl">
                <Trans i18nKey="doku_desc" />
              </p>

              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-10 rounded-full px-7 py-4
             bg-gradient-to-r from-[#bda088] to-[#a17f64]
             text-[#232c3b] font-semibold shadow-lg
             hover:from-[#f5e1cd] hover:to-[#d2b49a]
             transition-all duration-2000 ease-in-out"
              >
                {t("doku_cta")}
                <span aria-hidden>🖱️</span>
              </a>
            </div>

            {/* SAĞ: 2x2 image grid */}
            <div className="grid grid-cols-2 gap-5 lg:gap-6">
              {dokuImages.map((img) => (
                <div
                  key={img.id}
                  className="rounded-3xl overflow-hidden shadow-lg bg-[#101828]/40 aspect-[16/10]"
                >
                  <img
                    src={img.src}
                    alt={t(img.altKey) || "image"}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-[1.03]"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section
        id="deneyim"
        className="flex flex-col lg:flex-row w-full max-w-[1920px] mx_auto min-h-[680px]"
      >
        {/* SOL: KARARTMALI FOTOĞRAF */}
        <div className="relative flex-1 min-h-[400px] max-sm:rounded-t-2xl max-sm:overflow-hidden">
          <img
            src={"/fotoYeni.webp"}
            alt={t("doku_hero_alt") || "Doku Studio 3D"}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#19203a] opacity-50" />
        </div>

        {/* SAĞ: BEJ KUTU VE İÇERİK */}
        <div className="flex-1 flex flex-col justify-center px-6 md:px-16 py-12 bg-[#f4e3dd] min-h-[400px]">
          <h3 className="text-3xl md:text-4xl font-light text-[#232c3b] mb-2">
            {t("doku_block_kicker")}
          </h3>
          <h2 className="text-2xl md:text-3xl font-bold text-[#232c3b] mb-4">
            {t("doku_block_title")}
          </h2>

          {/* Doku Studio Logo */}
          <div className="flex items-center mb-6">
            <FaFlask size={36} className="text-[#232c3b] mr-3" />
            <span className="font-bold text-2xl tracking-widest text-[#232c3b]">
              STUDIO
            </span>
          </div>

          <p className="text-base md:text-lg text-[#232c3b] mb-6 max-w-xl">
            {t("doku_block_desc")}
          </p>

          <div className="font-bold text-[#232c3b] mb-3">
            {t("doku_awards_title")}
          </div>
          <div className="flex items-center gap-6 mb-8">
            <div className="flex flex-col items-center">
              <FaMedal size={44} className="text-[#d1b282]" />
              <span className="text-xs text-[#232c3b] font-semibold mt-2 text-center">
                {t("doku_award_1")}
              </span>
            </div>
            <div className="flex flex-col items-center">
              <FaAward size={44} className="text-[#c32f27]" />
              <span className="text-xs text-[#232c3b] font-semibold mt-2 text-center">
                {t("doku_award_2")}
              </span>
            </div>
          </div>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-[#10182b] hover:bg-[#283251] text-white font-bold text-base rounded-full px-8 py-4 shadow-lg transition-all duration-200 gap-2 w-full max-w-[430px] border-2 border-[#fff2] hover:border-[#bda088] whitespace-nowrap"
          >
            {t("doku_block_cta")}
            <span className="ml-1 text-lg">🖱️</span>
          </a>
        </div>
      </section>

      <Contact />
    </>
  );
}
